import { AddressDeliveryType } from '../../../../models/address-delivery-type';
import AddressResponseCode from '../../../../models/address-response-code-enum';
import client from '../../client';

const addressCreate = async (
  address: AddressDeliveryType,
  sessionId: string
): Promise<AddressResponseCode> => {
  const { data } = await client.post<AddressResponseCode>('/address/create', {
    provider: 0,
    sessionId,
    ...address,
  });

  return data;
};

export default addressCreate;
